import { render } from "./SocialMovement.vue?vue&type=template&id=08974418"
import script from "./SocialMovement.vue?vue&type=script&lang=js"
export * from "./SocialMovement.vue?vue&type=script&lang=js"

import "./SocialMovement.vue?vue&type=style&index=0&id=08974418&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__